import { ProductsActions } from "../../reducers/products/ActionsNames";
import { IPurchaseFormValues } from "../../containers/Purchase/PurchaseForm";

export default function (value: string) {
  return {
    type: ProductsActions.SetPaymentMethod,
    value,
  };
}
